import { Badge } from '@/components/ui/badge';
import { McpServerConnectionSafe } from '@vivport/backend/types';
import type { McpProbeState } from './mcp-connection-pin-result';

function formatPinnedAt(pinnedAt: string): string {
  return new Date(pinnedAt).toLocaleString();
}

export function McpConnectionCard({ connection, probe }: { connection: McpServerConnectionSafe; probe: McpProbeState | null }) {
  return (
    <div className="space-y-2">
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <span className="font-medium">{connection.name}</span>
          <Badge variant={connection.enabled ? 'default' : 'secondary'}>
            {connection.enabled ? 'Enabled' : 'Disabled'}
          </Badge>
          <Badge variant="outline">{connection.hasAuthValue ? 'Auth set' : 'No auth'}</Badge>
        </div>
        <p className="truncate text-sm text-muted-foreground">{connection.url}</p>
        {connection.pinnedTools.length > 0 ? (
          <p className="text-sm text-muted-foreground">
            Pinned {connection.pinnedTools.length} tool(s)
            {connection.pinnedAt ? ` · ${formatPinnedAt(connection.pinnedAt)}` : ''}:{' '}
            {connection.pinnedTools.map((tool) => tool.name).join(', ')}
          </p>
        ) : (
          <p className="text-sm text-muted-foreground">
            No tools pinned — Neo cannot use this connection until you pin.
          </p>
        )}
        {connection.drift && (
          <div className="text-sm">
            <p className="font-medium">Drift detected {formatPinnedAt(connection.drift.detectedAt)}</p>
            {connection.drift.added.length > 0 && (
              <p className="text-muted-foreground">Added: {connection.drift.added.join(', ')}</p>
            )}
            {connection.drift.removed.length > 0 && (
              <p className="text-muted-foreground">Removed: {connection.drift.removed.join(', ')}</p>
            )}
            {connection.drift.changed.length > 0 && (
              <p className="text-muted-foreground">
                Changed: {connection.drift.changed.map((entry) => `${entry.name} (${entry.field})`).join(', ')}
              </p>
            )}
          </div>
        )}
      </div>
      {probe && (
        <p className={`text-sm ${probe.kind === 'ok' ? 'text-muted-foreground' : 'text-destructive'}`}>{probe.text}</p>
      )}
    </div>
  );
}
